<div class="main-div">
  <diV style="width: 100%; padding: 24px;">
    <h2 class="faq-header">Clinical Documentation Look-up Tool</h2>
    <h3 class="faq-header">
      A new way to review Medical Policies and Utilization Management Guidelines for needed documentation.
    </h3>
    <p class="text">
      Using Medical Policies and UM Guidelines, we've developed a tool that supplies you with a list of recommended documents
      when submitting prior authorizations or claims. The new Clinical Documentation Look-up Tool uses the CPT and HCPC codes
      you enter to return real-time results.
    </p>
    <p class="text">
      Accessing the tool is easy, too. Either by visiting our provider website or through Payer Spaces on Availity.com.
    </p>
    <div style="margin: 15px 0px;">
      <img src="assets/images/cdltui.png" />
    </div>
    <p class="text">
      Start by entering in the member's plan type, state, and service dates. Enter the Procedure Code or use the Keyword
      Search box. The recommended documents will be returned along with a full copy of the Medical Policy.
    </p>

    <h2 class="faq-header">Frequently Asked Questions</h2>
    <div>
      <p class="text" style="font-weight: bold;">
        Why do I need to use the new Clinical Documentation Look-up Tool?
      </p>
      <p class="text" style="margin-left: 15px;">
        This tool was designed specifically to reduce the time you spend reviewing Medical Policies and UM Clinical Guidelines
        to determine what documents are needed when submitting an authorization or when submitting your claim for payment.
      </p>
    </div>

    <div>
      <p class="text" style="font-weight: bold;">
        Are all the Medical Policies and UM Guidelines included when returning results?
      </p>
      <p class="text" style="margin-left: 15px;">
        Yes. Medical Policies and UM Guidelines will return information based on the state you selected. We've developed
        the Tool to return information based on CPT and HCPC code to refine the search even further.
      </p>
    </div>

    <div>
      <p class="text" style="font-weight: bold;">
        Can I save the information and use it later?
      </p>
      <p class="text" style="margin-left: 15px;">
        There is a download feature that will enable you to download some, or all of the information needed.
        But, policies change, so it is important that you use the Clinical Documentation Look-up Tool when you need it.
        The Look-up Tool also returns information based on the specific information you enter, including the member state
        and policy type. It is important that you use that information each time you use the Look-up Tool to ensure you
        have the current, most up to date, and accurate information available.
      </p>
    </div>

    <div>
      <p class="text" style="font-weight: bold;">
        Can I use the Clinical Documentation Look-up Tool for all my member inquiries?
      </p>
      <p class="text" style="margin-left: 15px;">
        Right now, the Look-up Tool is specific to your Commercial member claims and prior authorizations. We plan to
        implement our Medicaid and Medicare member claims in 2024.
      </p>
    </div>

    <div>
      <p class="text" style="font-weight: bold;">
        How do I access the Clinical Documentation Look-up Tool?
      </p>
      <p class="text" style="margin-left: 15px;">
        There are two ways to access the Clinical Documentation Look-up Tool:
      </p>
      <ol type="1">
        <li>
          <p class="text">
            Through our public provider website. Use this link or from the Home page, select For Providers.
            Under the Provider Resources menu, select Policies, Guidelines & Manuals.
          </p>
        </li>
        <li>
          <p class="text">
            From Availity.com. Log onto Availity.com and select your state then use the Payer Spaces application to
            access the payer selection. The application will be on your Payer Spaces home page.
          </p>
        </li>
      </ol>   
    </div>

    <div>
      <p class="text" style="font-weight: bold;">
        Is there training available to learn how to use the new Clinical Documentation Look up Tool?
      </p>
      <p class="text" style="margin-left: 15px;">
        The new Look-up Tool was developed to be intuitive and easy to use! We've created a comprehensive demonstration you
        can access right from the Tool!
      </p>
    </div>

    <div style="margin: 15px 0px;">
      <img src="assets/images/cdltui_header.png" />
    </div>

    <div>
      <p class="text" style="font-weight: bold;">
        What if have additional questions or need more information?
      </p>
      <p class="text" style="margin-left: 15px;">
        Reach out to your provider relations manager or contact us through Chat with Payer, also available in Payer
        Spaces through Availity.com.
      </p>
    </div>
  </diV>
</div>
